<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Rekpitulasi Pengajuan Sidang
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Jenis Sidang</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.jenis_sidang_id"
            :options="jenisSidangOption.options"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Jenis Sidang"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status Pengajuan Sidang</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.status_pengajuan_sidang_id"
            :options="statusPengajuanOption.options"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Status Pengajuan Sidang"
          />
        </b-col>
        <b-col
          cols="4"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Judul File</label>
          <b-form-input 
            v-model="filter.judul"
            placeholder="Judul File"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="4">
          <label>Tanggal Mulai</label>
          <b-form-group
            label="Mulai Tanggal"
            label-for="mulai_tanggal"
          >
            <b-form-datepicker v-model="filter.mulai_tanggal" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <label>Tanggal Selesai</label>
          <b-form-group
            label="Sampai Tanggal"
            label-for="sampai_tanggal"
          >
            <b-form-datepicker v-model="filter.sampai_tanggal" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="download()">Download</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisSidang,
  getStatusPengajuanSidang,
  exportRekapitulasiPengajuanSidang,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusPengajuanOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Pengajuan Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
      getJenisSidang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenisSidangOption.options.push({
            label: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getStatusPengajuanSidang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.statusPengajuanOption.options.push({
            label: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));
  },
  methods: {
    async download()
    {
      this.showLoader = true
      const response = await exportRekapitulasiPengajuanSidang(this.filter)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Data Rekapitulasi Pengajuan Sidang.xlsx')
      document.body.appendChild(link)
      link.click()
      this.showLoader = false
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
